export const voiceOfCoachLight = '#3E65FF';
export const voiceOfCoachDark = '#2341CD';
export const alluvialColorsLight = ['#39D0DA', '#77D5FD', '#B28DEA', '#D270D4'];
export const alluvialColorsDark = ['#255F93', '#095099', '#7800BE', '#772B83'];
